import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdministradorRoutingModule } from './administrador-routing.module';
import { AltaCuestionariosComponent } from './alta-cuestionarios/alta-cuestionarios.component';
import { SharedModule } from '../../shared/shared.module';
import { EstructuracionComponent } from './estructuracion/estructuracion.component';
import { AddCategoryComponent } from './funciones/add-category/add-category.component';
import { AddQuestionsComponent } from './funciones/add-questions/add-questions.component';
import { PonderacionComponent } from './ponderacion/ponderacion.component';
import { ResponsablesPlanesComponent } from './responsables-planes/responsables-planes.component';


@NgModule({
  declarations: [
    AltaCuestionariosComponent,
    EstructuracionComponent,
    AddCategoryComponent,
    AddQuestionsComponent,
    PonderacionComponent,
    ResponsablesPlanesComponent
  ],
  imports: [
    CommonModule,
    AdministradorRoutingModule,
    SharedModule
  ]
})
export class AdministradorModule { }
